import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { accordionOpen } from 'store/ui/uiActions';

const useAccordionOpenEvent = () => {
  const dispatch = useDispatch();

  const accordionOpenEvent = useCallback(
    ({ groupName, itemName }) => {
      dispatch(
        accordionOpen({
          groupName: groupName,
          itemName: itemName,
        }),
      );
    },
    [dispatch],
  );
  return { accordionOpenEvent };
};

export default useAccordionOpenEvent;
